import request from '@/utils/request'

// 分页查询年级
export function reqGradePage(data) {
    return request({
        url: '/education/grade/page',
        method: 'post',
        data
    })
}

// 获取所有年级列表（不分页）
export function reqGradeList() {
    return request({
        url: '/education/grade/list',
        method: 'get'
    })
}

// 查询年级详情
export function reqGradeDetail(id) {
    return request({
        url: '/education/grade/detail',
        method: 'get',
        params: { id }
    })
}

// 新增年级
export function reqGradeInsert(data) {
    return request({
        url: '/education/grade/insert',
        method: 'post',
        data
    })
}

// 更新年级
export function reqGradeUpdate(data) {
    return request({
        url: '/education/grade/update',
        method: 'post',
        data
    })
}

// 删除年级
export function reqGradeDelete(id) {
    return request({
        url: '/education/grade/delete',
        method: 'get',
        params: { id }
    })
}

// 批量新增年级
export function reqGradeBatchInsert(data) {
    return request({
        url: '/education/grade/batchInsert',
        method: 'post',
        data
    })
}
